 
// src/redux/reducers/skillReducer.js
import {
    FETCH_SKILL_FAILURE,
    FETCH_SKILL_REQUEST,
    FETCH_SKILL_SUCCESS, 
    SET_SELECTED_SKILL 
  } from '../types';
  
  const initialState = {
    loading: false,
    skillList: [],
    selectedSkillId: null, 
    error: null,
  };
  
  const skillReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_SKILL_REQUEST:
        return { ...state, loading: true };
      case FETCH_SKILL_SUCCESS:
        return { ...state, loading: false, skillList: action.payload };
      case FETCH_SKILL_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case SET_SELECTED_SKILL:
        return { ...state, selectedSkillId: action.payload };
      default:
        return state;
    }
  };
  
  export default skillReducer;
  